// extracted by mini-css-extract-plugin
export default {"root":"CheckoutSection_root__oO+fq","mainContainer":"CheckoutSection_mainContainer__Q8J7A","paymentContainer":"CheckoutSection_paymentContainer__Ln6k1"};